var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:'post__loader ' + _vm.active,attrs:{"id":"postLoader"}},[_c('img',{style:(_vm.st ? _vm.st : ''),attrs:{"src":require("../assets/loading.png"),"alt":"loader"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }